function renderCampaignPages() {
  var dataScript = document.getElementById('magazine-data');
  if (!dataScript) {
    return false;
  }

  var magazineData;
  try {
    magazineData = JSON.parse(dataScript.textContent.trim());
  } catch (e) {
    return false;
  }

  if (!magazineData || !magazineData.campaign) {
    return false;
  }

  var $campaignLeftPage = null;
  var $campaignRightPage = null;
  var $campaignLeftWrapper = $('.flipbook-wrapper .page-wrapper[page="6"]');
  var $campaignRightWrapper = $('.flipbook-wrapper .page-wrapper[page="7"]');
  
  if ($campaignLeftWrapper.length > 0 && $campaignRightWrapper.length > 0) {
    $campaignLeftPage = $campaignLeftWrapper.find('.campaign-page.left-page');
    $campaignRightPage = $campaignRightWrapper.find('.campaign-page.right-page');
  }
  
  if (!$campaignLeftPage || $campaignLeftPage.length === 0) {
    $campaignLeftPage = $('.flipbook-wrapper .campaign-page.left-page');
    $campaignRightPage = $('.flipbook-wrapper .campaign-page.right-page');
  }

  if ($campaignLeftPage.length === 0 || $campaignRightPage.length === 0) {
    return false;
  }

  if ($campaignLeftPage.find('.campaign-images').length > 0) {
    return true;
  }

  var campaign = magazineData.campaign;
  var leftStyle = campaign.leftStyle || 0;
  var rightStyle = campaign.rightStyle || 0;
  var leftImages = campaign.leftImages || [];
  var rightImages = campaign.rightImages || [];

  var campaignLeftHtml = renderCampaignPageContent(leftImages, leftStyle);
  campaignLeftHtml += '<div class="page-number left-num">5</div>';

  var campaignRightHtml = renderCampaignPageContent(rightImages, rightStyle);
  campaignRightHtml += '<div class="page-number right-num">6</div>';

  $campaignLeftPage.html(campaignLeftHtml);
  $campaignRightPage.html(campaignRightHtml);

  setTimeout(function() {
    initCampaignMasonry();
  }, 100);

  return true;
}

function renderCampaignPageContent(images, style) {
  if (!images || images.length === 0) {
    return '<div class="campaign-images full-linear"></div>';
  }

  var styleClass = (style === 1) ? 'masonry-grid' : 'full-linear';
  
  var html = '<div class="campaign-images ' + styleClass + '">';
  
  if (style === 1) {
    html += '<div class="grid-sizer"></div><div class="gutter-sizer"></div>';
  }
  
  images.forEach(function(img) {
    html += '<picture>' +
      '<source srcset="' + img.urlWebP + '" type="image/webp">' +
      '<img class="campaign-image" src="' + img.url + '" loading="lazy" />' +
    '</picture>';
  });
  
  html += '</div>';
  
  return html;
}

function initCampaignMasonry() {
  $('.campaign-images.masonry-grid').each(function() {
    if (!$(this).data('masonry')) {
      $(this).masonry({
        itemSelector: '.campaign-image',
        columnWidth: '.grid-sizer',
        gutter: '.gutter-sizer',
        percentPosition: true
      });
    }
  });
}

$(document).ready(function() {
  $('#flipbook').on('turning', function(event, page, view) {
    if (page === 6 || page === 7 || view.indexOf(6) !== -1 || view.indexOf(7) !== -1) {
      setTimeout(function() {
        renderCampaignPages();
      }, 200);
    }
  });
  
  $('#flipbook').on('turned', function(event, page, view) {
    if (page === 6 || page === 7 || view.indexOf(6) !== -1 || view.indexOf(7) !== -1) {
      setTimeout(function() {
        renderCampaignPages();
      }, 200);
    }
  });

  waitForTurnJs(function() {
    var $flipbook = $('#flipbook');
    
    if ($flipbook.length && $flipbook.data('turn')) {
      var currentPage = $flipbook.turn('page');
      var view = $flipbook.turn('view');
      
      if (currentPage === 6 || currentPage === 7 || view.indexOf(6) !== -1 || view.indexOf(7) !== -1) {
        setTimeout(function() {
          renderCampaignPages();
        }, 300);
      }
    } else {
      setTimeout(function() {
        renderCampaignPages();
      }, 500);
    }
  });
});